// auth.service.ts
import { Injectable } from "@angular/core";
import {
  PublicClientApplication,
  AuthenticationResult,
} from "@azure/msal-browser";
import { msalConfig } from "./auth-config";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private msalInstance: PublicClientApplication;

  constructor() {
    this.msalInstance = new PublicClientApplication(msalConfig);
  }

  login() {
    this.msalInstance
      .loginPopup({
        scopes: [
          "email",
          "profile",
          "openid",
          // "0395f8d7-58bd-46de-a6dd-4561407864d6",
        ],
      })
      .then((response: AuthenticationResult | null) => {
        if (response) {
          console.log("Access Token:", response.accessToken);
          localStorage.setItem("access_token", response.accessToken);
          
        
        }
      });
    // this.msalInstance.loginRedirect({
    //   scopes: ['email','profile',"openid",'0395f8d7-58bd-46de-a6dd-4561407864d6']
    // });
  }

  handleRedirect() {
    // this.msalInstance
    //   .handleRedirectPromise()
    //   .then((response: AuthenticationResult | null) => {
    //     if (response) {
    //       console.log("Access Token:", response.accessToken);
    //       localStorage.setItem("access_token", response.accessToken);
    //     }
    //   })
    //   .catch((error) => console.error(error));
  }

  getAccount() {
    return this.msalInstance.getAllAccounts()[0];
  }

  acquireToken() {
    const account = this.getAccount();

    if (!account) {
      this.login();
      return;
    }

    this.msalInstance
      .acquireTokenSilent({
        scopes: ["user.read"],
        account,
      })
      .then((response) => {
        console.log("Silent token:", response.accessToken);
      })
      .catch(() => {
        this.msalInstance.acquireTokenRedirect({
          scopes: ["user.read"],
        });
      });
  }

  logout() {
    this.msalInstance.logoutRedirect();
  }
}
